// extracted by mini-css-extract-plugin
export var dataCell = "_pi-2";
export var dataRow = "_pi-0";
export var headerRow = "_pi-1";